export default __webpack_public_path__ + "static/media/gallery_13.41d4ba89.jpg";